const toastTypes = {
  DELETE_RESOURCE: "DELETE_RESOURCE",
  ERROR: "ERROR",
};

export { toastTypes };
